module.exports = __webpack_public_path__ + "img/logo-bank-sumselbabel-color.eb1ffa20.png";